let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Sjiq")).then(() => parcelRequire('7Mf2V'));